module.exports = __webpack_public_path__ + "img/sustainability-widget-desktop.14a20048.jpg";